module.exports = __webpack_public_path__ + "img/no-data-2.6b3b31af.svg";